import React from 'react';

const AboutUs = () => (
	<div className="container main">
		<h2>Quiénes somos</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Grupo de Trabajo de la OCDE sobre la seguridad de los productos de consumo</h4>
				<p>
					El <em>Portal Global de Alertas</em> es obra del <a href="http://www.oecd.org/sti/consumer/consumer-product-safety.htm">Grupo de Trabajo de la OCDE sobre la seguridad de los productos de consumo</a>.
					Su cometido es la mejora del intercambio de información y el fomento de una mayor cooperación entre las autoridades de vigilancia y control del mercado, policiales y reguladoras en el ámbito de la seguridad de los productos de todo el mundo para:
				</p>
				<ul className={'rss-feed-options'}>
					<li>detectar posibles problemas de seguridad existentes en una fase temprana;</li>
					<li>intercambiar información sobre buenas prácticas y novedades legislativas;</li>
					<li>explorar formas de enfrentarse a los problemas de seguridad de manera coherente;</li>
					<li>apoyar el trabajo de los foros mundiales y regionales.</li>
				</ul>
				<p>
					Uno de los principales logros del Grupo de Trabajo es la <a href="https://legalinstruments.oecd.org/en/instruments/OECD-LEGAL-0459">Recomendación de la OCDE en materia de seguridad de los productos de consumo</a>, que esboza los principios esenciales en los que
					deberían fundarse los sistemas nacionales e internacionales de seguridad de los productos de consumo y fomenta una mayor utilización del Portal Global de Alertas. Igualmente, el Grupo de
					Trabajo ha desarrollado y puesto a disposición de gobiernos y empresas un gran número de recursos complementarios dirigidos a lograr una retirada más eficaz de los productos, que pueden consultarse en su <a href="https://www.oecd.org/digital/consumer/consumer-product-safety.htm">sitio web</a>.
				</p>
			</div>
			<div className="col-sm-6">
				<h4 className="hidden-xs">&nbsp;</h4>
				<p>
					El Grupo de Trabajo es responsabilidad del <a href="https://www.oecd.org/sti/consumer/">Comité de la OCDE sobre Política de Protección al Consumidor</a> y ambos organismos colaboran habitualmente en cuestiones relacionadas con la protección de los consumidores, a través de numerosos proyectos y actos conjuntos.
				</p>
				<p>
					Además, el Grupo de Trabajo coopera estrechamente con organizaciones internacionales cuya actividad se enmarca en el ámbito de la seguridad de los productos, tales como la Asociación
					de Naciones del Asia Sudoriental (ASEAN), la Comisión Europea (CE), la Red internacional para la aplicación de la protección de los consumidores (International Consumer Protection
					Enforcement Network - ICPEN), la Organización Internacional de Política de Protección al Consumidor, Salud Pública y Seguridad de los Productos (ICPHSO), la Organización de los Estados
					Americanos (OAS) y la Conferencia de las Naciones Unidas sobre Comercio y Desarrollo (UNCTAD). Se han entablado asimismo estrechos vínculos con una serie de economías socias de la OCDE.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Contacte con nosotros</h4>
				<p>
					Si desea hacernos llegar cualquier pregunta o comentario acerca del Portal Global de Alertas, póngase en contacto con la Secretaría de la OCDE: <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>
				</p>
			</div>
		</div>
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/views/static/es/about-us.js